import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PatchScanPayload, ScanRes } from '../../types/Scan';
import { updateScan } from '../Scans';
import { getScanQueryKey } from './useGetScan';

export const useUpdateScan = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ scanId, payload }: { scanId: number; payload: PatchScanPayload }) => updateScan(scanId, payload),
        onSuccess: (result: ScanRes, variables) => {
            // Invalidate individual scan data
            queryClient.invalidateQueries({ queryKey: getScanQueryKey(result.id) });
            // Invalidate paginated scans list
            queryClient.invalidateQueries({ queryKey: ['scans'] });
        }
    });
};
